module.exports = __webpack_public_path__ + "img/score-0.3e352002.png";